module.exports = __webpack_public_path__ + "assets/person-gray-654105b33bbf1d7b6c22dfdb72b10418.svg";